import { useToastStore, type ToastType } from "@/stores/toastStore";

function useToast() {
  const { add } = useToastStore();

  function show(type: ToastType, message: string) {
    add({ type, message });
  }

  return {
    toast: {
      success: (message: string) => show("success", message),
      error: (message: string) => show("error", message),
      info: (message: string) => show("info", message),
    },
  };
}

export { useToast };
